import { defineMessages } from "react-intl";

export const formFieldControlText = defineMessages({
  required: {
    defaultMessage: "Required",
    id: "Seanpx",
  },
});
